import React from 'react';
import { useIntl } from 'react-intl';
import TFFTypography from '../../../../styled-components/TFFTypography';
import TFFIcon from '../../../../styled-components/TFFIcon';

interface NdcSearchHeaderProps {
  isFirstJourney: boolean;
}

const NdcSearchHeader: React.FC<NdcSearchHeaderProps> = ({ isFirstJourney }) => {
  const intl = useIntl();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '16px 0' }}>
      <TFFIcon
        iconName={isFirstJourney ? 'aircraft-right' : 'aircraft-left'}
        color="color-theme-variant"
      />
      <TFFTypography
        text={
          isFirstJourney
            ? intl.formatMessage({ id: 'rebook.directionOutbound' })
            : intl.formatMessage({ id: 'rebook.directionInbound' })
        }
        variant="lead"
        fontWeight="bold"
        modifier="uppercase"
      />
    </div>
  );
};

export default NdcSearchHeader;
